import React from "react";
import { CircularProgress, Box, Typography } from "@mui/material";

const Loader = () => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
    >
      <CircularProgress size={64} color="error" />
      <Typography variant="body2" color="textSecondary" marginTop={2}>
        Loading...
      </Typography>
    </Box>
  );
};

export default Loader;
